import { MdOutlineAdd } from 'react-icons/md';
import { IoMdTrash } from 'react-icons/io';

type Props = {
  isSelected: boolean;
};

const ToggleTierButton = ({ isSelected }: Props) => (
  <div className="bg-black text-white rounded-full flex align-center justify-center w-[32px] h-[32px]">
    {isSelected ? <IoMdTrash size={20} /> : <MdOutlineAdd size={24} />}
  </div>
);
export default ToggleTierButton;
